var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pulse-loader-wrapper",attrs:{"data-title":".dot-pulse"}},[_c('div',{staticClass:"dot --left"}),_c('div',{staticClass:"dot --center"}),_c('div',{staticClass:"dot --right"})])
}]

export { render, staticRenderFns }